import { useState } from "react";
import { Check, Copy, Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { ShareMenu } from "@/components/site/ShareMenu";

const isTouch = () => !!navigator.share && window.matchMedia("(pointer: coarse)").matches;

export const ShareFavoritesButton = ({ list }) => {
  const [busy, setBusy] = useState(false);
  const [url, setUrl] = useState(null);
  const text = `Ma sélection de ${list.length} titre${list.length > 1 ? "s" : ""} entendus sur la radio LGTDZ`;

  const create = async () => {
    setBusy(true);
    try {
      const tracks = list.map(({ artist, title, album, cover, buy_link }) => ({ artist, title, album, cover, buy_link }));
      const res = await fetch(`${API}/shared-favorites`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ tracks }) });
      if (!res.ok) throw new Error();
      const data = await res.json();
      const link = `${window.location.origin}/favoris/${data.id}`;
      setUrl(link);
      if (isTouch()) navigator.share({ title: "Mes favoris LGTDZ", text, url: link }).catch(() => {});
    } catch {
      toast.error("Impossible de créer le lien pour le moment.");
    } finally {
      setBusy(false);
    }
  };

  const copy = async () => {
    await navigator.clipboard.writeText(url);
    toast.success("Lien copié", { icon: <Check className="w-4 h-4" /> });
  };

  return (
    <div className="mt-8 space-y-4" data-testid="share-favorites">
      <button type="button" onClick={create} disabled={busy} data-testid="share-favorites-btn"
        className="inline-flex items-center gap-2 bg-primary text-white font-bold uppercase text-xs tracking-[0.2em] px-6 h-12 hover:bg-white hover:text-black transition-colors disabled:opacity-60">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Link2 className="w-4 h-4" />} {url ? "Nouveau lien à jour" : "Partager ma liste"}
      </button>
      {url && (
        <div className="flex flex-wrap items-center gap-2" data-testid="share-favorites-result">
          <input readOnly value={url} onFocus={(e) => e.target.select()} data-testid="share-favorites-url"
            className="h-11 min-w-0 flex-1 basis-56 bg-transparent border border-white/20 text-zinc-200 text-sm px-3" />
          <button type="button" onClick={copy} data-testid="share-favorites-copy"
            className="h-11 inline-flex items-center gap-2 border border-white/30 text-white text-[11px] uppercase tracking-[0.2em] font-bold px-4 hover:border-primary hover:text-primary transition-colors">
            <Copy className="w-4 h-4" /> Copier
          </button>
          <ShareMenu text={text} url={url} testId="share-favorites-menu" label={<span className="text-[11px] uppercase tracking-[0.2em] font-bold">Envoyer</span>}
            className="h-11 px-4 border border-white/30 text-white hover:border-primary hover:text-primary" />
        </div>
      )}
    </div>
  );
};
